import { ExternalLinks } from '../type'

const faqDomainUrl = 'https://faq.app.propulsebyca.fr/hc/fr'

export const CA_EXTERNAL_LINKS_FR: ExternalLinks = {
  cguLink:
    'https://assets.website-files.com/62bd73fb692211e3172975e4/633aed4914b3c41ea124cd52_CR%20-%20CGU_Plateforme%20de%20gestion%20Okali%20x%20Client%20final_VF%20(1).pdf',
  bankingOrganizationPrivacyPolicyLink:
    'https://assets.website-files.com/62bd73fb692211e3172975e4/633c5a4dd5457ace07c4d08f_Politique%20de%20protection%20des%20donnees%20Okali%20x%20Propulse_VF-n.pdf',
  brandPrivacyPolicyLink: 'https://info.propulsebyca.fr/caisses-regionales',
  appStoreLink: 'https://apps.apple.com/us/app/propulse-by-ca/id1623586276',
  googlePlayLink:
    'https://play.google.com/store/apps/details?id=com.creditagricole.pro',
  faq: faqDomainUrl,
  mandateSepa: `${faqDomainUrl}/articles/32439282223645-Comment-identifier-un-pr%C3%A9l%C3%A8vement-sepa-interentreprise`,
  invoicingFaq: `${faqDomainUrl}/articles/31506390078493-Comment-puis-je-cr%C3%A9er-une-facture-ou-un-devis`,
  requestHelp: `${faqDomainUrl}/articles/31932795040413-Comment-fonctionne-notre-service-client`,
  contactAdvisorPage: 'https://propulsebyca.fr/agence',
  rcProInfo: '',
  decadeGuaranteeInfo: '',
  multiriskInfo: '',
  legalPlaceCompany: 'https://heyflow.id/propulse-creation-corpo',
  helpNonDiffusible: `${faqDomainUrl}/articles/31624207528733-%C3%80-l-%C3%A9tape-Recherchez-votre-entreprise-mon-SIREN-SIRET-n-est-pas-retrouv%C3%A9-que-faire`,
  helpNonEligible: faqDomainUrl,
  helpNonAllowed: `${faqDomainUrl}/articles/31210571368477-Quelles-sont-les-conditions-pour-ouvrir-un-compte`,
  helpBeneficialOwners: `${faqDomainUrl}/articles/31178798608029-Qu-est-ce-qu-un-b%C3%A9n%C3%A9ficiaire-effectif`,
  urssaf: {
    portal: 'http://autoentrepreneur.urssaf.fr/',
    microEntrepreneurs:
      'https://www.autoentrepreneur.urssaf.fr/portail/accueil/sinformer-sur-le-statut/lessentiel-du-statut.html',
    socialContributions: 'http://www.aquoiserventlescotisations.urssaf.fr/',
    sepaMandate: faqDomainUrl,
    faq: faqDomainUrl,
    tdaeStatusHelp: faqDomainUrl,
    tdaePaymentAuthorization: faqDomainUrl,
    tou: 'https://assets.website-files.com/62bd73fb692211e3172975e4/633aed6e43278997c780d425_CR%20-%20CGU%20Tierce%20De%CC%81claration%20Client%20final%20x%20URSSAF_VF%20(1).pdf',
  },
  faqWhoIsBlankFor: faqDomainUrl,
  psdFAQ: faqDomainUrl,
  fatcaCGU: `https://www.datocms-assets.com/44717/1728317849-cgu-okali.pdf`,
  legalLink: 'https://info.propulsebyca.fr',
  supportEmail: 'support@app.propulsebyca.fr',
  securityEmail: 'securite@app.propulsebyca.fr',
  leadEmail: '',
  sepaTransfer: faqDomainUrl,
  compareOffers: 'https://propulsebyca.fr/tarifs',
  touBankAccount:
    'https://assets.website-files.com/62bd73fb692211e3172975e4/633aed5f1d4d477c75f4d99d_CR%20-%20Contrat%20cadre%20de%20services%20de%20paiement%20Okali%20x%20client%20final_VF%20(1).pdf',
  kycHelp: faqDomainUrl,
  legalStatus: 'https://propulsebyca.fr/statut-juridique',
  capitalDeposit: 'https://propulsebyca.fr/depot-capital-social',
  discoverManagementToolsOffer:
    'https://www.credit-agricole.fr/professionnel/acces-cr.html',
  sponsorshipFAQ: `${faqDomainUrl}/articles/31407294173341-Comment-fonctionne-le-parrainage-chez-Propulse`,
  priceBrochure:
    'https://assets.website-files.com/62bd73fb692211e3172975e4/6335c3f93bd65598eb4a584c_GrilletarifairePropulse.pdf',
  changeNonDiffusibleCompany: 'https://statut-diffusion-sirene.insee.fr',
  sponsorshipInvitationLink: '',
  transparencyPolicy: '',
  requestDeviceResetFAQ: `${faqDomainUrl}/articles/32503506752157-Comment-l-authentification-forte-s%C3%A9curise-t-il-mon-compte`,
  accountClosingFaq: `${faqDomainUrl}/articles/31234293211037-Comment-cl%C3%B4turer-mon-compte`,
  bankScamPreventionLink:
    'https://propulsebyca.fr/arnaque-faux-livret-propulse-by-ca',
  transferFAQ: `${faqDomainUrl}/articles/31254111670045-Quels-sont-les-d%C3%A9lais-de-r%C3%A9ception-de-mon-virement`,
  atecoCodeFAQ: '',
  partitaIVACertificateFAQ: '',
}
